import { makeApiCall } from '../_common/api.utils';
import { API_URL } from '../const';

/*********** SEND AADHAR OTP START ****************** */
export const sendAadharOtp = (getData: any) => {
	const data = {
		sendAadharOTPToken: getData,
	};
	const url = `${API_URL}sendAadharOtp`;
	return makeApiCall(url, data);
};
/*********** SEND AADHAR OTP END ****************** */

/*********** AADHAR OTP VERIFY START ****************** */
export const aadharOtpVerify = (getData: any) => {
	const data = {
		verifyAadharOTPToken: getData,
	};
	const url = `${API_URL}aadharOtpVerify`;
	return makeApiCall(url, data);
};
/*********** AADHAR OTP VERIFY END ****************** */
